import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";

const AddContactToGroup = ({ show, data, handleClose, onSubmit }) => {
  const { register, handleSubmit, reset } = useForm();

  const submitForm = (data) => {
    onSubmit(data);
    reset(); // Reset form setelah submit
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="sm"
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add To Group Contact</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(submitForm)}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Select Group Contact</label>
            <select className="form-select" {...register("group")}>
              {data.map((data, index) => (
                <option key={index} value={data.idt_contact_group}>
                  {data.name}
                </option>
              ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="success">
            Submit
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddContactToGroup;
